import $ from 'jquery';

if($('.interactive-map').length > 0) {
    var self = $('.interactive-map')[0];
    var observer = new IntersectionObserver(
        function (entries, observer) {
            var isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
            if (isIntersecting) {
                $.ajax({
                    url: '/typo3conf/ext/lfmsite/Resources/Public/Templates/Map.html',
                    context: document.body
                }).done(function (data) {
                    $('.interactive-map').find('.interactive-map__maps').html(data);

                    if($(window).width() < 768) {
                        $('.interactive-map__outer-wrap').scrollLeft(($('.interactive-map__map--berlin').width() / 2) - ($('.interactive-map__outer-wrap').width()));
                    }

                    $(document).on('click', function (e) {
                        if(!$(e.target).hasClass('interactive-map__marker') && !$(e.target).hasClass('interactive-map__popup') && $(e.target).closest('.interactive-map__popup').length < 1) {
                            $('.interactive-map__popup').removeClass('interactive-map__popup--active');
                        }
                    })

                    $('.interactive-map__marker').on('click', function () {
                        var id = $(this).data('id')
                        var $targetPopup = $('.interactive-map__popup[data-target="'+ id +'"]');
                        var $wrap = $(this).closest('.interactive-map');
                        $targetPopup.siblings('.interactive-map__popup').removeClass('interactive-map__popup--active');
                        $targetPopup.toggleClass('interactive-map__popup--active');

                        if($(window).width() > 768) {
                            $targetPopup.css('top',$(this).offset().top - $wrap.offset().top - 200+'px');
                            $targetPopup.css('left',$(this).offset().left + $wrap.find('.interactive-map__outer-wrap').scrollLeft() - $wrap.offset().left + $wrap.scrollLeft() - 315 - 10 +'px');
                        } else  {
                            $targetPopup.css('top',$(this).offset().top - 10 - $targetPopup.height() +'px');
                        }
                    })

                    $('.interactive-map__toggle-option').on('click', function (){
                        $(this).siblings().removeClass('interactive-map__toggle-option--active');
                        $(this).addClass('interactive-map__toggle-option--active');
                        $('.interactive-map__popup').removeClass('interactive-map__popup--active');
                        $('.interactive-map__outer-wrap').scrollLeft($('.interactive-map__outer-wrap').width() / 2);
                        if($(this).hasClass('interactive-map__toggle-option--berlin')) {
                            $(this).closest('.interactive-map__toggler').addClass('interactive-map__toggler--switch');
                            $(this).closest('.interactive-map').find('.interactive-map__maps').addClass('interactive-map__maps--switch')
                        } else {
                            $(this).closest('.interactive-map').find('.interactive-map__maps').removeClass('interactive-map__maps--switch')
                            $(this).closest('.interactive-map__toggler').removeClass('interactive-map__toggler--switch');
                        }
                    });
                })
                observer.unobserve(self);
            }
        },  {
            rootMargin: '300px'
        }
    );

    observer.observe(self);
}
